import React, {Component, PropTypes} from 'react';
import defaultStyle from './defaultStyle';
import {MentionsInput, Mention} from 'react-mentions';
import {Map} from "immutable";
import {RaisedButton} from 'material-ui';
import {Icon} from 'antd';
import * as srv from '../../../services';

export default class PopupMentions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commentInput: '',
            commentText: '',
            commenTo: [],
            refMention: [],
        }
    }

    static propTypes = {
        usersMap: PropTypes.object,
        mentionUsers: PropTypes.array,
        devices: PropTypes.array,
        from: PropTypes.string,
        token: PropTypes.string,
        engineerID: PropTypes.number,
        saleID: PropTypes.number,
        issueID: PropTypes.number,
    };

    static defaultProps = {
        usersMap: Map({}),
        mentionUsers: [],
        devices: [],
        from: '',
        token: '',
        engineerID: 0,
        saleID: 0,
        issueID: 0,
    };

    async saveNewComment() {
        if (!this.state.commentText || this.state.commentText.length === 0) {
            return;
        }

        let commentText = this.state.commentText;
        if (commentText.length === 0) {
            return;
        }

        this.setState({waitingPostComment: true});

        let commenTo = [];
        let refUser = [];
        let refMention = [];

        if (this.state.commentTo && this.state.commentTo.length > 0) {
            commenTo = this.state.commentTo;
        }

        if (this.state.refMention && this.state.refMention.length > 0) {
            refMention = this.state.refMention;
        }

        if (this.props.engineerID && this.props.engineerID > 0) {
            let engineer = this.props.usersMap.get(this.props.engineerID.toString());
            if (engineer) {
                refUser.push(this.props.engineerID);

                const mail = engineer.get('mail');

                if (mail.length > 0) {
                    commenTo.push(mail);
                }
            }
        }

        if (this.props.saleID && this.props.saleID > 0) {
            let sale = this.props.usersMap.get(this.props.saleID.toString());
            if (sale) {
                refUser.push(this.props.saleID);

                const mail = sale.get('mail');
                if (mail.length > 0) {
                    commenTo.push(mail);
                }
            }
        }

        let comment = {
            issueID: this.props.issueID,
            subject: this.props.subject,
            from: this.props.from,
            to: commenTo,
            text: commentText,
            refUser: refUser,
            refMention: refMention,
            type: 'comment',
            username: this.props.username
        };

        let data = await srv.postComment(comment, this.props.token);
        if (data) {
            this.setState({waitingPostComment: false});

            if (data.status === 200 && data.history) {
                this.props.handleChange(data.history, 'savedHistory');
            }
        }
    }

    render() {
        return (
            <span style={{display: this.props.issueID > 0 ? 'block' : 'none'}}>
                <MentionsInput
                    value={this.state.commentInput}
                    placeholder={"Mention user, device using @, #"}
                    displayTransform={(id, display, type) => {
                        if (type === 'user') {
                            return `@${display}`
                        }

                        return `#${display}`
                    }}
                    markup="@[__display__](__type__)"
                    onChange={(event, newValue, newPlainTextValue, mentions) => {
                        let commentTo = [];
                        let refMention = [];

                        if (mentions && mentions.length > 0) {
                            mentions.map((mention) => {
                                if (mention.type === 'user') {
                                    let arrCheckValid = mention.id.split('@');

                                    if (arrCheckValid && arrCheckValid.length === 2) {
                                        let arrGetEmail = mention.id.split('#');

                                        if (arrGetEmail && arrGetEmail.length === 2) {
                                            commentTo.push(arrGetEmail[1]);
                                            refMention.push(parseInt(arrGetEmail[0]));
                                        }
                                    }
                                }
                            });
                        }

                        this.setState({
                            commentText: newPlainTextValue,
                            commentInput: event.target.value,
                            commentTo: commentTo,
                            refMention: refMention,
                        });
                    }}
                    style={defaultStyle}
                >
                    <Mention
                        type="user"
                        appendSpaceOnAdd
                        trigger="@"
                        data={this.props.mentionUsers}
                        renderSuggestion={(suggestion, search, highlightedDisplay) => {
                            return <div className="user-here">
                                {highlightedDisplay}
                            </div>;
                        }}
                    />
                    <Mention
                        type="device"
                        appendSpaceOnAdd
                        trigger="#"
                        data={this.props.devices}
                        renderSuggestion={(suggestion, search, highlightedDisplay) => {
                            return <div className="user-here">
                                {highlightedDisplay}
                            </div>;
                        }}
                    />
                </MentionsInput>

                <RaisedButton
                    className={'button-loading'}
                    disabled={this.state.waitingPostComment}
                    label="Comment"
                    primary={true}
                    style={{float: 'right', margin: '10px 0'}}
                    onTouchTap={(event) => this.saveNewComment()}
                    disabledBackgroundColor={this.state.waitingPostComment ? 'rgba(21, 101, 192, 0.58)' : 'rgb(229, 229, 229)'}
                    disabledLabelColor={this.state.waitingPostComment ? '#fff' : '#ccc'}
                    icon={<Icon type="loading"
                                style={{
                                    color: '#fff', position: 'relative',
                                    top: '-3px', marginLeft: '6px',
                                    fontSize: '13px', fontWeight: '600',
                                    display: this.state.waitingPostComment ? 'inline-flex' : 'none'
                                }}/>}
                />
            </span>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/schedule/popup/popupMentions.js